/**
 * Full-screen maintenance page shown to non-admin users when maintenance mode is enabled.
 * Renders outside the AppShell (no sidebar/footer) — standalone static page.
 */
export function MaintenancePage() {
  return (
    <div className="min-h-screen bg-bg-primary flex flex-col items-center justify-center px-4 text-center">
      <img src="/logo192.png" alt="Lynx Crypto" className="w-16 h-16 mb-6 opacity-80" />

      <h1 className="text-2xl font-bold text-text-primary mb-2">
        Down for Maintenance
      </h1>

      <p className="text-text-secondary max-w-md mb-8">
        We're performing scheduled maintenance to improve the platform.
        We'll be back shortly — thank you for your patience.
      </p>

      <div className="flex items-center gap-2 text-text-muted text-sm">
        <span className="w-2 h-2 rounded-full bg-warning animate-pulse" />
        <span>Maintenance in progress</span>
      </div>

      <a
        href="/login"
        className="mt-10 text-xs text-text-muted hover:text-accent transition-colors"
      >
        Admin login
      </a>
    </div>
  );
}
